export const defaultQueryOptions = {
  count: 100,
  offset: 0
};